import styled from '@emotion/styled';
import { Divider, Radio, tokens } from '@hotjar/hotsauce';
import { PlanFeatures } from '@hotjar/webapp/features/Billing/Upsell/components/PlanFeatures/PlanFeatures';

export const PlanSelectionItemStyles = {
  PlanSelectionItem: styled('div')`
    flex-grow: 1;
    width: 100%;
  `,
  Radio: styled('div')<{ disabled: boolean }>`
    width: 100%;
    position: relative;
    color: ${(props) => (props.disabled ? tokens.color.text_disabled : tokens.color.text_default)};
  `,
  RadioInput: styled(Radio)`
    margin: 0;
    float: right;
  `,
  RadioLabel: styled('label')<{ selected: boolean; tall: boolean }>`
    width: 100%;
    background: ${tokens.color.white};
    padding: ${tokens.spacer.x2pt5} ${tokens.spacer.x2};
    cursor: pointer;
    border: ${(props) =>
      props.selected
        ? `1px solid ${tokens.color.ui_border_active}`
        : `1px solid ${tokens.color.ui_border}`};
    ${tokens.elevation(4)};
    border-radius: ${tokens.radius.m};
    text-transform: none;
    margin: 0;
    min-height: ${(props) => (props.tall ? '120px' : '98px')};
    display: block;

    &:focus,
    &:hover {
      border: 1px solid ${tokens.color.ui_border_alt};
    }
  `,
  RadioMainInfo: styled('div')`
    display: flex;
    justify-content: space-between;
    margin-top: ${tokens.spacer.x1pt5};
    align-items: flex-start;
    gap: ${tokens.spacer.x1};
  `,
  Allowance: styled('div')`
    padding: 0 ${tokens.spacer.x2};
  `,
  FixedHeightAllowanceText: styled.span`
    ${tokens.text('body1')};

    display: flex;
    flex-direction: column;
    height: ${tokens.spacer.x5};
    justify-content: flex-end;
  `,
  FixedHeightCoverageWrapper: styled.span`
    height: ${tokens.spacer.x2};
  `,
  PlanFeaturesDivider: styled(Divider)`
    border-color: ${tokens.color.neutral_400};
    margin: 0 ${tokens.spacer.x2};
    max-width: 100px;
  `,
  StyledPlanFeatures: styled(PlanFeatures)`
    padding: 0 ${tokens.spacer.x2};
  `,
};
